export function hideFieldWhenFilterDependent(field, filterValues) {
  if(field?.props?.dependentOnFilter == null || typeof field.props.dependentOnFilter !== "function") return false;
  return field.props.dependentOnFilter(filterValues);
}